import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PolicyMinimalModel,
  PolicyModel,
  PolicyToAdd,
  PolicyToUpdateModel,
} from 'src/app/models/api/governance/policy.model';
import { HttpService } from '../../http/http.service';
import { FileDownloadModel } from 'src/app/models/api/fileDownload.model';

export enum RuleType {
  risk = 'risk', // violation rules tab
  hygiene = 'hygiene', // hygiene rules tab
}

@Injectable({
  providedIn: 'root',
})
export class PoliciesHttpService {
  private readonly _policiesBaseUrl: string = 'governance/policies';

  constructor(private readonly _httpService: HttpService) {}

  /**
   * @public Get all the existing policies on the account.
   * @returns an Observable{PolicyMinimalModel[]} with the policies returned from server. Returns a model policy object with fewer details than the complete model.
   */
  public getPolicies(): Observable<PolicyMinimalModel[]> {
    const url = `${this._policiesBaseUrl}`;
    return this._httpService.get<PolicyMinimalModel[]>(url);
  }

  public getIntegrationPolicies(integrationId: string): Observable<PolicyModel[]> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}`;
    return this._httpService.get<PolicyModel[]>(url);
  }

  public getPolicy(integrationId: string, policyId: string): Observable<PolicyModel> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}/policy/${policyId}`;
    return this._httpService.get<PolicyModel>(url);
  }

  public updatePolicy(
    integrationId: string,
    policyId: string,
    detailsToUpdate: PolicyToUpdateModel
  ): Observable<string> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}/policy/${policyId}`;
    return this._httpService.put<string, PolicyToUpdateModel>(url, detailsToUpdate);
  }

  public addPolicy(integrationId: string, policyToAdd: PolicyToAdd): Observable<string> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}`;
    return this._httpService.post<PolicyToAdd, string>(url, policyToAdd);
  }

  public deleteCustomPolicy(integrationId: string, policyId: string): Observable<string> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}/policy/${policyId}`;
    return this._httpService.delete<string>(url);
  }

  public exportPolicyRules(integrationId: string, policyId: string, ruleType: RuleType): Observable<FileDownloadModel> {
    const url = `${this._policiesBaseUrl}/integration/${integrationId}/policy/${policyId}/rules/export?ruleType=${ruleType}`;
    return this._httpService.get<FileDownloadModel>(url);
  }
}
